import ActionModel from 'frontend/models/action';
import type ProductModel from 'frontend/models/product';

export function getProductIdFromModel(
  productOrAction: ActionModel | ProductModel
) {
  if (productOrAction instanceof ActionModel) {
    if (!productOrAction.product) {
      throw new Error("ActionModel's product must be loaded");
    }
    return productOrAction.product.get('id') as string;
  }
  return productOrAction.get('id');
}
